import React from "react";
import LazyLoad from "react-lazy-load";
import { sharedConstants } from "../../../constants";
import { ReactComponent as HearthIcon } from "../../../assets/icons/hearth.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faPlay } from "@fortawesome/free-solid-svg-icons";


const FilePreview = ({
  files = [],
  selectedFiles = [],
  showCheckbox = true,
  showPlayButton = true,
  showLockIcon = true,
  isModalOpen = false,
  isModalAllowed = true,
  isAuthenticated = false,
  isSBAuthenticated = false,
  isShareAllowed = false,
  isAllowLock = false,
  onFileSelect,
  onOpenModal,
  lazyLoadThreshold = 0.95,
  showHearthIcon = false,
  isFavoriteReadOnly = false,
  favoriteClipHandle,
}) => {
  const handleSelect = (file) => {
    if (onFileSelect) {
      onFileSelect(file);
    }
  };

  const handleOpenModal = (index) => {
    if (onOpenModal) {
      onOpenModal(index);
    }
  };

  const isMediaTypeImage = (url) => {
    const imageExtensions = /\.(jpg|jpeg|png|gif|bmp|webp)$/i;
    return imageExtensions.test(url);
  };

  const filteredFiles =
    files?.filter(
      (file) => file.url !== sharedConstants.IS_GALLERY_UPLOAD_PREVIEW
    ) || [];

  const shouldShowCheckbox =
    showCheckbox && !isModalOpen && (isAuthenticated || isSBAuthenticated);
  const shouldShowPlayButton = showPlayButton && !isModalOpen;
  const shouldShowLockIcon =
    showLockIcon && !isModalOpen && (isAllowLock || isShareAllowed);

  const canShowHearthIcon =
    showHearthIcon &&
    !isModalOpen &&
    (isFavoriteReadOnly || isAuthenticated || isSBAuthenticated);
    
  return (
    <div className="col-12 px-0 p-0 grid gallery-file-grid">
      {filteredFiles.map((file, index) => (
        <div
          key={file?.id || index}
          className={`file-item px-0 ${
            file.selected ? "selected" : ""
          } grid-col-4 grid-col-md-4 grid-col-lg-3`}
        >
          {canShowHearthIcon &&
            (!isFavoriteReadOnly || file.isFavorite) && (
            <HearthIcon
              className={`gallery-hearth-icon ${
                file.isFavorite ? "filled" : ""
              } ${isFavoriteReadOnly ? "" : "cursor-pointer"}`}
              onClick={
                isFavoriteReadOnly
                  ? undefined
                  : () => favoriteClipHandle?.(file.id)
              }
            />
          )}
          {/* Checkbox */}
          {shouldShowCheckbox && (
            <label className="checkbox-container access-gallery-checkbox">
              <input
                type="checkbox"
                checked={
                  isShareAllowed && file.isLocked
                    ? false
                    : selectedFiles.includes(file)
                }
                onChange={() => handleSelect(file)}
              />
              {isShareAllowed && file.isLocked ? (
                ""
              ) : (
                <span className="checkmark"></span>
              )}
            </label>
          )}

          {/* Play Button for Non-Images */}
          {shouldShowPlayButton && !file.file?.type.startsWith("image/") && (
            <div
              className="play-button-container"
              onClick={(e) => {
                if (isModalAllowed) {
                  e.preventDefault();
                  handleOpenModal(index);
                }
              }}
            >
              <FontAwesomeIcon icon={faPlay} size="lg" />
            </div>
          )}

          {/* Lock Icon */}
          {shouldShowLockIcon && file.isLocked && (
            <div className="lock-container">
              <FontAwesomeIcon icon={faLock} />
            </div>
          )}

          {/* File Content */}
          <div className="aspect-ratio-container">
            {file.file?.type.startsWith("image/") ? (
              <LazyLoad height={"fit-content"} threshold={lazyLoadThreshold}>
                <img
                  src={file?.id ? file.thumbnailUrl : file.url}
                  alt=""
                  className={`
                    ${
                      selectedFiles.includes(file)
                        ? "selected-gallery-image file-content"
                        : "file-content"
                    } obj-fit-cover`}
                  onClick={() => {
                    if (isModalAllowed) handleOpenModal(index);
                  }}
                />
              </LazyLoad>
            ) : (
              <LazyLoad height={"fit-content"} threshold={lazyLoadThreshold}>
                {file?.id && isMediaTypeImage(file.thumbnailUrl) ? (
                  <img
                    src={file?.id ? file.thumbnailUrl : file.url}
                    alt=""
                    className={`
                      ${
                        selectedFiles.includes(file)
                          ? "selected-gallery-image file-content"
                          : "file-content"
                      } obj-fit-cover`}
                    onClick={() => {
                      if (isModalAllowed) handleOpenModal(index);
                    }}
                  />
                ) : (
                  <video
                    src={
                      file?.id ? `${file.thumbnailUrl}#t=0.001` : `${file.url}`
                    }
                    autoPlay={file?.id ? false : true}
                    muted={true}
                    preload="auto"
                    className={`${
                      selectedFiles.includes(file)
                        ? "selected-gallery-image col-12 px-0 h-100 file-content"
                        : "col-12 px-0 h-100 file-content"
                    } obj-fit-cover`}
                    onClick={(e) => {
                      if (isModalAllowed) {
                        e.preventDefault();
                        handleOpenModal(index);
                      }
                    }}
                  />
                )}
              </LazyLoad>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FilePreview;
